// Présélection des pupitres à la création selon le style du groupe (jamais verrouillée, toujours décochable).
export const STYLE_PUPITRE_PRESETS = {
  pipeband: ["Cornemuse", "Caisse claire", "Ténor", "Basse"],
  bagad: ["Cornemuse", "Bombarde", "Caisse claire", "Percussion"],
};

// Pupitres cochés par défaut : liste canonique du style, ou toutes les pratiques du groupe si "autre".
export function presetPupitres(group) {
  const instruments = group?.instruments || [];
  const preset = STYLE_PUPITRE_PRESETS[group?.style];
  return preset ? [...preset] : [...instruments];
}

// Cases affichées : canoniques du style d'abord, puis les pratiques du groupe (sans doublon).
export function pupitreChoices(group) {
  const instruments = group?.instruments || [];
  const preset = STYLE_PUPITRE_PRESETS[group?.style] || [];
  return [...new Set([...preset, ...instruments])];
}
